import styled from '@emotion/styled';
import { mq } from 'src/styles'

const MobileHide = styled.div`
  ${mq.mediumAndBelow} {
    display: none;
  }
`;

export default MobileHide